export const zodToFormData = (
  data: Record<string, string>,
  formData: FormData,
  leaveAsIs: Array<string> = []
) => {
  Object.keys(data).forEach((key) => {
    if (!formData.has(key)) {
      formData.append(key, data[key]);
    } else if (!leaveAsIs.includes(key)) {
      formData.set(key, data[key]);
    }
  });
  return formData;
};

type FormDataObject = Record<string, string | number | FormDataEntryValue> & {
  _strip?: Array<string>;
};

export const formDataToObject = (formData: FormData) => {
  const dataObject: FormDataObject = {};
  formData.forEach((value, key) => {
    // just add the file size in stead of the file to the object
    if (typeof value !== 'object' && value !== '') {
      dataObject[key] = value.toString();
    } else if (typeof value === 'object') {
      // safely check the size of file(s)
      if (Array.isArray(value) && value.length > 0) {
        if ('size' in value[0]) {
          const sum = value.reduce((sum, current: File) => {
            return sum + current.size;
          });
          dataObject[key] = sum;
        }
      } else if ('size' in value) {
        dataObject[key] = value.size;
      }

      dataObject._strip = dataObject._strip ? [...dataObject._strip, key] : [key];
    }
  });

  return dataObject;
};
